import React, { ReactElement } from 'react';
import { Title } from '../page-components/Title';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';

const webhooksNavigationLinks = [
	{
		path: 'webhooks',
		name: 'MENU.WEBHOOKS'
	},
	{
		path: 'activity-logs',
		name: 'MENU.LOGS'
	},
];

interface Props {
	children: ReactElement;
}

export const WebhooksPageLayout = (props: Props): React.ReactElement => {
	const { children } = props;
	const { t } = useTranslation();
	const { pathname } = useLocation();
	const routeName = pathname.split('/')[2];

	return (
		<>
			<div className="card mb-10">
				<div className="card-header d-flex align-items-center">
					<Title
						title={routeName === 'webhooks' ? t('MENU.WEBHOOKS') : t('MENU.LOGS')}
						additionalClass="fs-2 fw-bolder"
					/>
				</div>
				<div className="d-flex align-items-center merchant-navigation px-9">
					{
						webhooksNavigationLinks.map(({ path, name }) => (
							<Link
								key={path}
								to={`/developers/${path}`}
								className={clsx(
									'd-flex align-items-center justify-content-center fs-8 fs-sm-7 fw-bolder px-3 h-70px tab-style',
									routeName === path ? 'text-danger tab-bgc' : 'text-dark'
								)}
							>
								{t(name)}
							</Link>
						))
					}
				</div>
			</div>
			{children}
		</>
	);
};
